// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   Card,
//   Chip,
//   CircularProgress,
//   Alert,
//   Grid,
// } from "@mui/material";
// import config from "../../../config";
// // Field labels for UI
// const FIELD_LABELS = {
//   product_name: "Product Name",
//   product_description: "Description",
//   product_code: "Product Code",
//   brand_name: "Brand",
//   product_type: "Product Type",
//   collection_name: "Collection",
//   product_price: "Price",
//   inventory_quantity: "Inventory",
//   is_boost: "Boosted",
//   weight_unit: "Weight Unit",
//   thc_content_pct: "THC Content (%)",
//   cbd_content_pct: "CBD Content (%)",
//   strain_name: "Strain Name",
//   mood: "Mood",
//   tags: "Tags",
//   created_date: "Created Date",
//   modified_date: "Last Modified",
//   store_pos_product_id: "Product ID",
//   master_pos_product_id: "Master Product ID",
//   pos_product_id: "POS Product ID",
//   is_cannabis_specific: "Cannabis Specific",
//   image_url: "Image URL",
// };
 
// // Format values for display
// const formatValue = (key, value) => {
//   if (value === null || value === undefined) return "N/A";
//   if (typeof value === "boolean") return value ? "Yes" : "No";
//   if (Array.isArray(value)) return value;
//   if (key.includes("date")) return new Date(value).toLocaleString();
//   if (key === "product_price") return `$${Number(value).toFixed(2)}`;
 
//   // Handle JSON string arrays like tags
//   if (typeof value === "string" && (value.startsWith("[") || value.startsWith("{"))) {
//     try {
//       const parsed = JSON.parse(value);
//       if (Array.isArray(parsed)) return parsed;
//     } catch {}
//   }
 
//   return value;
// };
 
// const ProductDetails = () => {
//   const { pos_product_id ,product_code  } = useParams();
//   const params = useParams();
 
//   console.log(params)
//   const navigate = useNavigate();
//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
 
//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         setLoading(true);
//         // const res = await fetch(`/api/product-details/${product_code}`); // Uses proxy
//         const res = await fetch(`${config.API_BASE_URL}product/details/${product_code}`);
//         console.log("response --->>",res)
//         if (!res.ok) throw new Error("Network response not ok");
 
//         const json = await res.json();
//         if (!json.status) {
//           setError(json.message || "Failed to fetch product details");
//           setProduct(null);
//         } else {
//           setProduct(json.data);
//         }
//       } catch (err) {
//         setError(err.message || "Error fetching product details");
//         setProduct(null);
//       } finally {
//         setLoading(false);
//       }
//     };
 
//     fetchProduct();
//   }, [product_code]);
 
//   if (loading)
//     return (
//       <Box display="flex" justifyContent="center" mt={6}>
//         <CircularProgress />
//       </Box>
//     );
 
//   if (error)
//     return (
//       <Box mt={6} mx={2}>
//         <Alert severity="error">{error}</Alert>
//       </Box>
//     );
 
//   if (!product) return null;
 
//   return (
//     <Box sx={{ p: 4, backgroundColor: "#F6F7F9", minHeight: "100vh" }}>
//       {/* Breadcrumb */}
//       <Box sx={{ mb: 3 }}>
//         <Typography variant="body2" sx={{ color: "#64748B" }}>
//           <span
//             onClick={() => navigate("/")}
//             style={{ cursor: "pointer", color: "#605DFF" }}
//           >
//             Home
//           </span>{" "}
//           &gt;{" "}
//           <span
//             onClick={() => navigate("/products")}
//             style={{ cursor: "pointer", color: "#605DFF" }}
//           >
//             Products
//           </span>{" "}
//           &gt; <span style={{ color: "#64748B" }}>{product.product_name}</span>
//         </Typography>
//       </Box>
 
//       {/* Title & Brand */}
//       <Box sx={{ mb: 3 }}>
//         <Typography variant="h4" fontWeight="700" sx={{ color: "#1E293B", mb: 1 }}>
//           {product.product_name}
//         </Typography>
//         {product.brand_name && (
//           <Typography variant="body1" sx={{ color: "#64748B" }}>
//             by {product.brand_name}
//           </Typography>
//         )}
//       </Box>
 
//       {/* Product Image */}
//       {product.image_url && (
//         <Box sx={{ mb: 4 }}>
//           <img
//             src={product.image_url}
//             alt={product.product_name}
//             style={{ maxWidth: "300px", borderRadius: "8px" }}
//           />
//         </Box>
//       )}
 
//       {/* Product Details Grid */}
//       <Grid container spacing={3}>
//         {Object.keys(FIELD_LABELS).map((key) => {
//           const value = product[key];
//           if (value === null || value === undefined) return null;
 
//           const formattedValue = formatValue(key, value);
//           const isArray = Array.isArray(formattedValue);
 
//           return (
//             <Grid item xs={12} sm={6} md={4} key={key}>
//               <Card sx={{ p: 2, borderRadius: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: "#64748B",
//                     fontWeight: 600,
//                     textTransform: "uppercase",
//                     fontSize: "0.7rem",
//                     letterSpacing: "0.5px",
//                   }}
//                 >
//                   {FIELD_LABELS[key]}
//                 </Typography>
//                 {isArray ? (
//                   <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                     {formattedValue.map((item, idx) => (
//                       <Chip key={idx} label={item} size="small" />
//                     ))}
//                   </Box>
//                 ) : (
//                   <Typography variant="body2" sx={{ mt: 0.5 }}>
//                     {formattedValue}
//                   </Typography>
//                 )}
//               </Card>
//             </Grid>
//           );
//         })}
//       </Grid>
//     </Box>
//   );
// };
 
// export default ProductDetails;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  Chip,
  CircularProgress,
  Alert,
  Grid,
} from "@mui/material";
import config from "../../../config";

// Field labels for UI
const FIELD_LABELS = {
  product_name: "Product Name",
  product_description: "Description",
  product_code: "Product Code",
  brand_name: "Brand",
  product_type: "Product Type",
  collection_name: "Collection",
  product_price: "Price",
  inventory_quantity: "Inventory",
  is_boost: "Boosted",
  weight_unit: "Weight Unit",
  thc_content_pct: "THC Content (%)",
  cbd_content_pct: "CBD Content (%)",
  strain_name: "Strain Name",
  mood: "Mood",
  tags: "Tags",
  created_date: "Created Date",
  modified_date: "Last Modified",
  store_pos_product_id: "Product ID",
  master_pos_product_id: "Master Product ID",
  pos_product_id: "POS Product ID",
  is_cannabis_specific: "Cannabis Specific",
  image_url: "Image URL",
};

const formatValue = (key, value) => {
  if (value === null || value === undefined) return "N/A";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (Array.isArray(value)) return value;
  if (key.includes("date")) return new Date(value).toLocaleString();
  if (key === "product_price") return `$${Number(value).toFixed(2)}`;

  // JSON arrays from API
  if (typeof value === "string" && (value.startsWith("[") || value.startsWith("{"))) {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
    } catch {}
  }

  return value;
};

const ProductDetails = () => {
  const { product_id } = useParams(); // store_pos_product_id is passed as product_id in route
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);

        // ⭐ Fetch using store_pos_product_id
        const res = await fetch(
          `${config.API_BASE_URL_V1}/admin/product/details/${product_id}`,
          { headers: config.getHeaders() }
        );

        if (!res.ok) throw new Error("Network error");

        const json = await res.json();
        console.log("DETAILS RESPONSE:", json);

        // Your backend uses success=true/false NOT status
        if (!json.success) {
          setError(json.message || "Unable to fetch product details");
          return;
        }

        setProduct(json.data);
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [product_id]);

  if (loading)
    return (
      <Box display="flex" justifyContent="center" mt={6}>
        <CircularProgress />
      </Box>
    );

  if (error)
    return (
      <Box mt={6} mx={2}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );

  if (!product) return null;

  return (
    <Box sx={{ p: 4, backgroundColor: "#F6F7F9", minHeight: "100vh" }}>
      {/* Breadcrumb */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ color: "#64748B" }}>
          <span
            onClick={() => navigate("/")}
            style={{ cursor: "pointer", color: "#605DFF" }}
          >
            Home
          </span>{" "}
          &gt;{" "}
          <span
            onClick={() => navigate("/products")}
            style={{ cursor: "pointer", color: "#605DFF" }}
          >
            Products
          </span>{" "}
          &gt; <span style={{ color: "#64748B" }}>{product.product_name}</span>
        </Typography>
      </Box>

      {/* Title */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight="700" sx={{ color: "#1E293B", mb: 1 }}>
          {product.product_name}
        </Typography>

        {product.brand_name && (
          <Typography variant="body1" sx={{ color: "#64748B" }}>
            by {product.brand_name}
          </Typography>
        )}
      </Box>

      {/* Product Image */}
      {product.image_url && (
        <Box sx={{ mb: 4 }}>
          <img
            src={product.image_url}
            alt={product.product_name}
            style={{ maxWidth: "300px", borderRadius: "8px" }}
          />
        </Box>
      )}

      {/* Product Details */}
      <Grid container spacing={3}>
        {Object.keys(FIELD_LABELS).map((key) => {
          const value = product[key];
          if (value === null || value === undefined) return null;

          const formattedValue = formatValue(key, value);
          const isArray = Array.isArray(formattedValue);

          return (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <Card sx={{ p: 2, borderRadius: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#64748B",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    fontSize: "0.7rem",
                  }}
                >
                  {FIELD_LABELS[key]}
                </Typography>

                {isArray ? (
                  <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {formattedValue.map((v, i) => (
                      <Chip key={i} label={v} size="small" />
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {formattedValue}
                  </Typography>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ProductDetails;
